import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from "antd";
import {ModalCustom} from "components/common";
import React, {useState, useEffect, useMemo, useRef} from "react";
import {employeeService, medicalExaminationService, receiveService} from "api";
import "./ReceiveInfo.scss";
import Notification from "components/common/notification/notification";
import {AddBtnSVG} from "assets";
import ModalAddGroup from "./ModalAdd/ModalAddGroup";

const ReceiveInfo = props => {
  // const action = useAppSelector((state) => state.receive);
  const {form} = props;
  const modalRef = useRef<any>();

  const [objects, setObjects] = useState<any>([]);
  const [group, setGroup] = useState<any>();
  const [employee, setEmployee] = useState<any>();
  const [isShowGroup, setIsShowGroup] = useState<any>();
  const [type, setType] = useState(true);
  const [sourcePatient, setSourcePatient] = useState<any>([]);
  const [loaiKCB, setLoaiKCB] = useState<any>([]);
  const nguonBn = Form.useWatch("nguonBn", form);
  useEffect(() => {
    if (nguonBn == "Đoàn khám tại viện") {
      setIsShowGroup(true);
    } else setIsShowGroup(false);
  }, [nguonBn]);
  useEffect(() => {
    fetchObjects();
    fetchSourcePatient();
    fetchLoaiKCB();
    getLitGroup();
    searchEmployee();
  }, []);
  const fetchObjects = async () => {
    try {
      let response = await medicalExaminationService.getListObjects();
      if (response.status == 200) {
        setObjects(response.data);
      }
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  // Layas danh sách nân viên của viện
  const searchEmployee = async () => {
    const param = {
      page: 1,
      limit: 1000,
    };
    try {
      let response = await employeeService.searchEmployee(param);
      // if (response.status == 200) {
      setEmployee(response.items);
      // }
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh sách nhân viên");
    }
  };
  const getLitGroup = async () => {
    try {
      let response = await receiveService.getLitGroup();
      // if (response.status == 200) {
      setGroup(response);
      // }
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đoàn khám");
    }
  };

  //Lấy danh sách nguồn bệnh nhân
  const fetchSourcePatient = async () => {
    try {
      let response = await medicalExaminationService.getSourcePatient();
      if (response.status == 200) {
        setSourcePatient(response.data);
      }
    } catch (err) {
      Notification(
        "error",
        "Lỗi xảy ra khi lấy thông tin danh mục nguồn bênh nhân"
      );
    }
  };
  const fetchLoaiKCB = async () => {
    try {
      let response = await medicalExaminationService.getListLoaiKCB();
      if (response.status == 200) {
        setLoaiKCB(response.data);
      }
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục loại khám chữa bệnh");
    }
  };
  const toObjectOptions = objs => {
    return objs.map(v => {
      return {value: v.id, label: v.tenDoiTuong};
    });
  };
  const toSourcePatientOptions = objs => {
    return objs.map(v => {
      return {value: v.tenNguonBenhNhan, label: v.tenNguonBenhNhan};
    });
  };
  const toLoaiKCB = objs => {
    return objs.map(v => {
      return {value: v.id, label: v.tenLoaiKCB};
    });
  };

  const handleAddGroup = () => {
    modalRef.current.openModal();
    setType(false);
  };

  // useEffect(() => {}, [objects, sourcePatient, loaiKCB]);
  // useMemo(() => {
  //   if (
  //     action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI ||
  //     action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI
  //   ) {
  //     // form.resetFields()
  //     console.log("vào đâyyyy");

  //     form.setFieldValue("loaiKcb", toLoaiKCB(loaiKCB)?.[0]?.value);
  //   }
  // }, [loaiKCB, action]);
  // useEffect(() => {
  //   if (
  //     action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI ||
  //     action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI
  //   ) {
  //     form.setFieldValue("ngayNhapVien", dayjs());
  //   }
  // }, [action]);
  return (
    <Row className="receive-info">
      <Row>
        <Typography.Text strong>
          Thông tin tiếp nhận (ngày nhập viện)
        </Typography.Text>
      </Row>
      <Divider type="horizontal" />
      <Row>
        <Form labelAlign="left" form={form}>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={
                  <Typography.Text ellipsis>Ngày nhập viện</Typography.Text>
                }
                name="ngayNhapVien"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                rules={[
                  {required: true, message: "Ngày nhập viện là bắt buộc"},
                ]}
              >
                <DatePicker
                  className="data-picker-field"
                  placeholder="HH:mm DD/MM/YYYY"
                  format={"HH:mm DD/MM/YYYY"}
                  disabled={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Loại KCB</Typography.Text>}
                name="loaiKcb"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                rules={[{required: true, message: "Loại KCB là bắt buộc"}]}
              >
                <Select
                  className="data-select-field"
                  placeholder="Chọn"
                  options={loaiKCB ? toLoaiKCB(loaiKCB) : []}
                  allowClear
                  disabled={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={
                  <Typography.Text ellipsis>Nguồn bệnh nhân</Typography.Text>
                }
                name="nguonBn"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <AutoComplete
                  showSearch
                  allowClear
                  notFoundContent={null}
                  defaultActiveFirstOption={false}
                  filterOption={(inputValue, option) =>
                    option!.label
                      .toString()
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  options={
                    sourcePatient ? toSourcePatientOptions(sourcePatient) : []
                  }
                  disabled={true}
                ></AutoComplete>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Đối tượng</Typography.Text>}
                name="doiTuong"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Select
                  className="data-select-field"
                  placeholder="Chọn"
                  options={objects ? toObjectOptions(objects) : []}
                  allowClear
                  disabled={true}
                />
              </Form.Item>
            </Col>
            {nguonBn == "Đoàn khám tại viện" && (
              <>
                <Col xs={24} sm={24} md={12} lg={11} xl={11}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Tên đoàn</Typography.Text>}
                    name={nguonBn == "Đoàn khám tại viện" ? "tenDoan" : null}
                    labelAlign="left"
                    labelCol={{span: 9}}
                    wrapperCol={{span: 15}}
                  >
                    <Select
                      className="data-select-field"
                      placeholder="Chọn"
                      options={
                        group
                          ? group.map(e => ({
                              value: e.tenDoanKham,
                              label: e.tenDoanKham,
                            }))
                          : []
                      }
                      allowClear
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
            {nguonBn == "Nhân viên giới thiệu" && (
              <>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Tên NV</Typography.Text>}
                    name={
                      nguonBn == "Nhân viên giới thiệu" ? "nvKinhDoanh" : null
                    }
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                  >
                    <Input
                      className="data-select-field"
                      allowClear
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
                {/* <Col span={1}>
                  <Button
                    type="primary"
                    id="btn-add-group"
                    icon={<AddBtnSVG />}
                    onClick={handleAddGroup}
                  />
                </Col> */}
              </>
            )}
            {nguonBn == "Nhân viên kinh doanh" && (
              <>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Tên NV</Typography.Text>}
                    name={
                      nguonBn == "Nhân viên kinh doanh" ? "tenNhanVien" : null
                    }
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                  >
                    <Select
                      className="data-select-field"
                      allowClear
                      disabled={true}
                      options={
                        employee.map(e => ({
                          value: e.hoTen,
                          label: e.hoTen,
                        })) || []
                      }
                    />
                  </Form.Item>
                </Col>
                {/* <Col span={1}>
                  <Button
                    type="primary"
                    id="btn-add-group"
                    icon={<AddBtnSVG />}
                    onClick={handleAddGroup}
                  />
                </Col> */}
              </>
            )}
            {nguonBn == "CTV" && (
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<Typography.Text ellipsis>Tên CTV</Typography.Text>}
                  name={nguonBn == "CTV" ? "tenCTV" : null}
                  labelAlign="left"
                  labelCol={{span: 8}}
                  wrapperCol={{span: 16}}
                >
                  <Input
                    className="data-select-field"
                    allowClear
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Từ viện</Typography.Text>}
                name="tuVien"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input className="data-input-field" disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Tai nạn</Typography.Text>}
                name="taiNan"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input className="data-input-field" disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Nơi làm</Typography.Text>}
                name="noiLam"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input className="data-input-field" disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                label={
                  <Typography.Text ellipsis>Loại bệnh nhân</Typography.Text>
                }
                name="loaiBenhNhans"
                labelAlign="left"
                labelCol={{span: 4}}
                wrapperCol={{span: 20}}
              >
                <Checkbox.Group disabled={true}>
                  <Checkbox value={0}>Cấp cứu</Checkbox>
                  <Checkbox value={2}>Người khuyết tật</Checkbox>
                  <Checkbox value={4}>Phụ nữ có thai</Checkbox>
                  <Checkbox value={5}>VIP</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
      <ModalCustom title="Đoàn khám" ref={modalRef}>
        <ModalAddGroup
          getLitGroup={getLitGroup}
          dataAddGroup={group}
          type={type}
          setType={setType}
        />
      </ModalCustom>
    </Row>
  );
};

export default ReceiveInfo;
